import { selectEntityStatus } from "../ui/ui.selectors";
import { STYLIZATIONS } from "./stylizations.reducer";

export const selectStylizationsPagination = (state) => state[STYLIZATIONS].pagination;
export const selectStylizationsItems = (state) => state[STYLIZATIONS].items;
export const selectStylizations = (state) => state[STYLIZATIONS];
export const selectStylizationsStatus = (state) => selectEntityStatus(state, STYLIZATIONS);
